<section class="cta-panel section">
  <div class="cta-panel__inner container">
    <h2 class="cta-panel__title type-md-title-h6 title-dark">{{ title() }}</h2>

    <div class="cta-panel__cta">
      <app-button fullWidth [href]="ctaButtonLink()">{{ ctaButtonText() }}</app-button>
      <app-button fullWidth variant="secondary-dark" href="mailto:enterprise@evrn.world">
        Enterprise
      </app-button>
    </div>

    @if (showPictureCredits()) {
      <div class="cta-panel__credits">
        <p class="cta-panel__credits-title type-title-h8">Picture Credits</p>

        <ul class="cta-panel__credits-list">
          @for (credit of pictureCredits(); track credit.name) {
            <li class="cta-panel__credits-item">
              <span class="cta-panel__credits-name type-body-b3">{{ credit.name }}: </span>
              <span class="cta-panel__credits-work type-body-b3">{{ credit.work }}</span>
            </li>
          }
        </ul>
      </div>
    }
  </div>
</section>
